import update from 'immutability-helper';

import { SET, ADDED, UPDATED, DELETED } from './actions';
import * as questionsActions from "../questions/actions";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.javascripts;

    case ADDED:
      return {
        ...state,
        [action.javascript.id]: action.javascript
      };

    case UPDATED:
      return update(state, {
        [action.javascript.id]: {
          $set: action.javascript
        }
      });
    case DELETED:
      return update(state, {
        $unset: [action.javascript.id]
      });

    case questionsActions.TYPE_UPDATED:
      const ids = [];

      _.each(state, javascript => {
        if (javascript.question.id === action.expiredId)
          ids.push(javascript.id);
      });

      return update(state, {
        $unset: ids
      });

    default:
      return state;
  }
};